import React from "react";
import DataLoading from "../DataLoading";
import InputField from "./QuestionsComponents/InputField";
import AutoComplete from "./QuestionsComponents/AutoComplete";
import CheckBox from "./QuestionsComponents/CheckBox";
import RadioQuestion from "./QuestionsComponents/Radio";
import CheckboxesTags from "./QuestionsComponents/CheckBoxesTags";
import LinearSliderQuestion from "./QuestionsComponents/LinearSliderQuestion";
import MultiSelectQuestion from "./QuestionsComponents/MultiSelectQuestion";
import CheckboxInput from "./QuestionsComponents/CheckBoxInput";
import NonLinearQuestion from "./QuestionsComponents/NonLiearQuestion";
import Box from "@mui/material/Box";
import InputRadio from "./QuestionsComponents/InputRadio";
import WebAppDate from "./QuestionsComponents/WebAppDate";
import InputNumberQuestion from "./QuestionsComponents/InputNumberQuestion";
import MultiTagsJson from "./QuestionsComponents/MultiTagsJson";


export default function EditQuestions({
                                          isLoaded,
                                          question,
                                          goToNextQuestion,
                                          addQuestion,
                                          deleteQuestionsAfterIndex ,
                                          isVisible,
                                          addToUpdateQuestions,
                                          deleteFromQuestionToUpdate,
                                          setQuestionToUpdate
}) {

    if (isLoaded) {
        return <DataLoading />;
    }

    if (!question) {
        return null; // Avoid rendering when question is null
    }


    return (
        <Box>
            {(() => {
                switch (question?.type) {
                    case "input":
                    case "textField":
                        return <InputField
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "inputField":
                        return <InputNumberQuestion
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                            setQuestionToUpdate={setQuestionToUpdate}
                        />
                    case "autocomplete":
                        return <AutoComplete
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "checkbox":
                        return <CheckBox
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "radio":
                        return <RadioQuestion
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "inputRadio":
                        return <InputRadio
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "slider":
                        return <LinearSliderQuestion
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "nonLinear":
                        return <NonLinearQuestion
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "multiTagsJson":
                        return <MultiTagsJson
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />
                    case "multiTags":
                        return <CheckboxesTags
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "checkbox_multiselection":
                        return <MultiSelectQuestion
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "checkboxInput":
                        return <CheckboxInput
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    case "date":
                        return <WebAppDate
                            data={question}
                            goToNextQuestion={goToNextQuestion}
                            addQuestion={addQuestion}
                            deleteQuestionsAfterIndex={deleteQuestionsAfterIndex}
                            isVisible={isVisible}
                            addToUpdateQuestions={addToUpdateQuestions}
                            deleteFromQuestionToUpdate={deleteFromQuestionToUpdate}
                        />;
                    default:
                        return question?.type;
                }
            })()}

        </Box>
    );
}
